import { render, staticRenderFns } from "./error-modal.vue?vue&type=template&id=2e4e9d9a&scoped=true&"
import script from "./error-modal.js?vue&type=script&lang=js&"
export * from "./error-modal.js?vue&type=script&lang=js&"
import style0 from "./error-modal.scss?vue&type=style&index=0&id=2e4e9d9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4e9d9a",
  null
  
)

export default component.exports